package dev.kuml.portal.web.projects

import dev.kuml.portal.web.i18n.strings.EditorStrings
import dev.kuml.portal.web.i18n.strings.ProjectsStrings

/**
 * DISPLAY-ONLY localisation of the two server-assigned default names ([DEFAULT_PROJECT_NAME] and
 * the "Diagramm N" pattern, see `editor/EditorScreen.kt`'s `defaultDiagramTabNamePattern`). NEVER
 * used for comparison, never sent to the server, never persisted -- both wire/comparison values
 * remain untranslated (see [DEFAULT_PROJECT_NAME]'s own KDoc for why translating them would break
 * auto-naming and the project list's created-at metaline for every existing project).
 *
 * A user who deliberately names a diagram "Diagramm 2" will see "Diagram 2" in the English UI --
 * accepted, and arguably the friendlier behaviour (this wave's plan, decision E-7).
 */
public object DefaultNameDisplay {
    private val diagramNamePattern = Regex("^Diagramm (\\d+)$")

    public fun projectName(
        stored: String,
        strings: ProjectsStrings,
    ): String = if (stored == DEFAULT_PROJECT_NAME) strings.defaultProjectNameDisplay else stored

    public fun diagramName(
        stored: String,
        strings: EditorStrings,
    ): String {
        val match = diagramNamePattern.matchEntire(stored) ?: return stored
        val n = match.groupValues[1].toIntOrNull() ?: return stored
        return strings.defaultDiagramName(n)
    }
}
